module.exports = __webpack_public_path__ + "static/media/gear.cd214502.svg";